import { Navigate } from 'react-router-dom';

/**
 * Rôles et permissions sont regroupés sous `/admin-users-management`.
 * Ancienne route conservée pour favoris et liens existants.
 */
const MultiRoleUserProfiles = () => (
  <Navigate to="/admin-users-management?tab=reference&view=roles" replace />
);

export default MultiRoleUserProfiles;
